module.exports = __webpack_public_path__ + "static/img/ct.30ffece.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/cn/ct.png
// module id = lz2D
// module chunks = 1